import { RoomSideBarTabs } from "@multiconsult-group/multiplacer-core";
export const isValidationPanelTab = (tab: RoomSideBarTabs | undefined) =>
  tab === RoomSideBarTabs.RFP_STANDARD_ROOM_DIFF || tab === RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES;

/** Keep the existing Redux tab values, but show one navigation entry for validation. */
export function groupValidationPanelTabs(tabs: RoomSideBarTabs[]): RoomSideBarTabs[] {
  let added = false;
  return tabs.filter(tab => {
    if (!isValidationPanelTab(tab)) return true;
    if (added) return false;
    added = true;
    return true;
  });
}

export function validationTabForColor(color: string | undefined): RoomSideBarTabs | undefined {
  if (/^(decision:)?standardRoom\.[^.]+$/.test(color ?? "")) return RoomSideBarTabs.RFP_STANDARD_ROOM_DIFF;
  if (color?.startsWith("specifiedArticles.")) return RoomSideBarTabs.ROOM_SPECIFIED_ARTICLES;
  return undefined;
}
